export default "__VITE_ASSET__UP415_iF__"